import type { hc } from 'hono/client';
import type { AppType } from '@minutes-system/backend/src/app';
import { refreshResponseSchema } from '@minutes-system/backend/src/api/auth/schema';

const refreshSession = async (publicClient: ReturnType<typeof hc<AppType>>): Promise<string> => {
  const res = await publicClient.auth.refresh.$post();
  if (!res.ok) {
    throw new Error('refresh failed status ' + String(res.status));
  }
  const data = refreshResponseSchema.parse(await res.json());
  return data.accessToken;
};

export default refreshSession;
